import { Box } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { AdCostMessage } from "../ad/form/AdCostMessage";
import { AdVertical } from "@/sell/models/AdVerticals";
import { CreateAd } from "@/sell/actions/CreateAd";
import { useRouter } from "next/navigation";
import { useLazySession } from "@/app/layout/useLazySession";
import {
  CreateAdViewModel,
  CreateAdViewModelSchema,
} from "@/sell/models/CreateAdViewModel";
import { AD_OFFER_DETAILS_DEFAULTS } from "@/sell/models/AdDetails";
import { zodResolver } from "@hookform/resolvers/zod";
import AdPricingDetails from "../ad/[id]/details/AdPricingDetails";

export function SellCreateForm({ vertical }: { vertical: AdVertical }) {
  const { isLoaded, isAuthenticated } = useLazySession();
  const methods = useForm<CreateAdViewModel>({
    resolver: zodResolver(CreateAdViewModelSchema),
    defaultValues: {
      vertical,
      details: AD_OFFER_DETAILS_DEFAULTS,
    },
  });
  const router = useRouter();
  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        onSubmit={methods.handleSubmit(async (data) => {
          if (!isLoaded || !data.details) {
            return;
          }
          const createAdViewModel: CreateAdViewModel = {
            vertical: vertical,
            details: {
              price: data.details.price,
              priceType: data.details.priceType,
              priceCurrency: data.details.priceCurrency,
              type: data.details.type,
            },
          };
          if (!isAuthenticated) {
            router.push(
              "/auth?returnUrl=/sell/ad/create/" +
                btoa(JSON.stringify(createAdViewModel)),
            );
            return;
          }
          const ad = await CreateAd(createAdViewModel);
          router.push(`/sell/ad/${ad.id}/details`);
        })}
        noValidate
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: 4,
            maxWidth: "1200px",
            margin: "0 auto",
            [theme.breakpoints.down("sm")]: {
              gap: 2,
            },
          })}
        >
          <Box
            sx={{
              paddingTop: 2,
              paddingBottom: 2,
            }}
          >
            <AdPricingDetails />
          </Box>
          <AdCostMessage />
        </Box>
      </Box>
    </FormProvider>
  );
}
